import React from 'react';
import { Field, FastField } from 'formik';
import FromToPickerField from 'customField/FromToPickerField';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.placeholder
 * @param {(dateRange) => void} props.afterOnChange
 * @param {boolean} props.disableSelectTime
 * @param {boolean} props.disableSelectMinutes
 * @param {boolean} props.isClearable
 * @param {boolean} props.required
 * @param {boolean} props.v2
 * @returns
 */
const DateRange = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={FromToPickerField} {...props} />;
};

export default DateRange;
